import { useReducer } from 'react'
import { SimpleBuilding, SimpleMerchant} from '@exaleap/common'
import leasingReducer, { State } from '../reducers/leasing'
import leasingActions from '../actions/leasingActions'

const initialState: State = {
  buildings: [],
  merchants: [],
}

export type LeasingState = {
  buildings: SimpleBuilding[],
  merchants: SimpleMerchant[],
  setBuildings: (buildings: SimpleBuilding[]) => void,
  setMerchants: (buildings: SimpleMerchant[]) => void,
}

const useLeasing = (): LeasingState => {
  const [leasing, leasingDispatcher] = useReducer(leasingReducer, initialState)
  const { setBuildings, setMerchants } = leasingActions(leasingDispatcher)

  return {
    ...leasing,
    setBuildings,
    setMerchants,
  }
}

export default useLeasing
